import {
  Builderlyags3ldja2y as Builder,
  Builder3vv3qt9kyowg0 as Builder_0,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.f6g_1 = (new (Builder())('input')).v39();
        this.g6g_1 = (new (Builder())('input')).v39();
        this.h6g_1 = (new (Builder())('input')).v39();
        this.i6g_1 = (new (Builder())('input')).v39();
        this.j6g_1 = (new (Builder())('input')).v39();
        this.k6g_1 = (new (Builder())('input')).v39();
        this.l6g_1 = (new (Builder())('input')).v39();
        this.m6g_1 = (new (Builder())('input')).v39();
        this.n6g_1 = (new (Builder())('input')).v39();
        this.o6g_1 = (new (Builder())('input')).v39();
        this.p6g_1 = (new (Builder())('input')).v39();
        this.q6g_1 = (new (Builder())('input')).v39();
        this.r6g_1 = (new (Builder())('input')).v39();
        this.s6g_1 = (new (Builder())('input')).v39();
        this.t6g_1 = (new (Builder())('input')).v39();
        this.u6g_1 = (new (Builder())('input')).v39();
        this.v6g_1 = (new (Builder())('input')).v39();
        this.w6g_1 = (new (Builder())('input')).v39();
        this.x6g_1 = (new (Builder())('input')).v39();
        this.y6g_1 = (new (Builder_0())('Mutation')).v39();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceoymipm3rjnhd,
};
//endregion

//# sourceMappingURL=Mutation.mjs.map
